import type { FSA } from 'types/redux';
import _ from 'lodash';
import { GET_RULE_TYPES, GET_RULE_OBJECT_TYPES } from 'actions/rule-types';
import * as RequestResultCases from 'middlewares/api-middleware';

export type RuleTypesState = {
  entities: Object,
  ruleObjectTypesHash: Object,
};

export const defaultRuleTypesState = {
  entities: {},
};

const ruleTypes = (state: RuleTypesState = defaultRuleTypesState, action: FSA): RuleTypesState => {
  switch (action.type) {
    case GET_RULE_TYPES + RequestResultCases.SUCCESS:
      return {
        ...state,
        entities: {
          ...state.entities,
          [action.meta.type]: _.get(action.payload, 'ruleTypes', action.payload),
        },
      };
    case GET_RULE_OBJECT_TYPES + RequestResultCases.SUCCESS:
      return {
        ...state,
        ruleObjectTypesHash: action.payload,
      };
    default:
      return state;
  }
};

export default ruleTypes;
